import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { business } from "@/data/site";

export default function PageHero({ kicker, title, subtitle, image }) {
  return (
    <section className="relative border-b border-charcoal/15" data-testid="page-hero">
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-charcoal/75" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        {kicker && (
          <p className="font-accent uppercase tracking-[0.25em] text-sm text-cream/70 mb-3">{kicker}</p>
        )}
        <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl uppercase text-cream leading-[0.9] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-base md:text-lg text-cream/85 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <a
            href={business.phoneHref}
            data-testid="pagehero-call"
            className="inline-flex items-center justify-center gap-2 bg-rust text-cream border border-cream/40 shadow-md hover:-translate-y-0.5 transition-all font-heading text-xl uppercase px-6 py-3"
          >
            <Phone className="w-5 h-5" /> Call {business.phone}
          </a>
          <Link
            to="/contact"
            data-testid="pagehero-estimate"
            className="inline-flex items-center justify-center gap-2 bg-cream text-charcoal border border-charcoal/20 shadow-md hover:-translate-y-0.5 transition-all font-heading text-xl uppercase px-6 py-3"
          >
            Request an Estimate
          </Link>
        </div>
      </div>
    </section>
  );
}
